"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _utils = require("@package/utils");

var _storybook = require("@pikassa/storybook");

var _hoc = require("@package/hoc");

var _react = _interopRequireDefault(require("react"));

var _reduxForm = require("redux-form");

var _reactRedux = require("react-redux");

var _Form = _interopRequireDefault(require("./Form"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function useGetSelectedShopId() {
  var shops = (0, _reactRedux.useSelector)(_functionalButton.selectShops);
  var formData = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('operation-payout-from-file'));

  if (formData && 'shopId' in formData) {
    return formData['shopId'];
  }

  return shops.length ? shops[0]['id'] : null;
}

function HOC() {
  try {
    var handleSubmit = function handleSubmit(data) {
      dispatch((0, _functionalButton.createPayoutFromFile)({
        shopId: data['shopId'],
        payouts: file['data']['payouts']
      }));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var file = (0, _reactRedux.useSelector)(_functionalButton.selectFile);
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInProcess);
    var selectedShopId = useGetSelectedShopId();
    (0, _hoc.useMount)(function () {
      dispatch((0, _functionalButton.getShops)({
        minAmount: 10,
        include: ['additionalSettings', 'payoutMethods', 'transferRoutes']
      }));
    });
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });

    if (inProcess) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['spinner']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null));
    }

    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      initialValues: {
        externalId: (0, _utils.uuid)(),
        shopId: selectedShopId
      },
      onSubmit: function onSubmit(data) {
        return handleSubmit(data);
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;